import React from 'react';

import {useIsDesktop} from '../../hooks/useIsDesktop';
import ViewDesktop from './viewDesktop';
import ViewMobile from './viewMobile';
import {Props} from './model';

export const NewsCarousel: React.FC<Props> = (props) => {
  const isDesktop = useIsDesktop();

  const View = isDesktop ? ViewDesktop : ViewMobile;
  return <View {...props} />;
};
